import { useSelector } from "react-redux";



const GlobalCurrency = ({ price }) => {
    const currency = useSelector((state) => state.getSetting?.dataSetting?.currency);
    return (
        <>
        {price < 0 ? `-${currency} ${(-price).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` 
                      : `${currency} ${price ? parseFloat(price).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "0.00"}`}
      </>
    )
    
}

export default GlobalCurrency;